import { HOME } from "@constants/routes";
import logo from "@images/shared/logo.png";
import PropTypes from "prop-types";
import { MouseEventHandler, ReactElement } from "react";
import { Link } from "react-router-dom";
import TopbarProfile from "./TopbarProfile";
import TopbarSidebarButton from "./TopbarSidebarButton";

interface ITopbar {
  changeMobileSidebarVisibility: MouseEventHandler<HTMLButtonElement>;
  changeSidebarVisibility: MouseEventHandler<HTMLButtonElement>;
}

const Topbar = ({
  changeMobileSidebarVisibility,
  changeSidebarVisibility,
}: ITopbar): ReactElement => (
  <div className="topbar">
    <div className="topbar__wrapper">
      <div className="topbar__left">
        <TopbarSidebarButton
          onClickMobile={changeMobileSidebarVisibility}
          onClickDesktop={changeSidebarVisibility}
        />
        <Link
          className="topbar__logo"
          style={{ backgroundImage: `url(${logo})` }}
          to={HOME}
        ></Link>
      </div>
      <div className="topbar__right">
        <TopbarProfile />
      </div>
    </div>
  </div>
);

Topbar.propTypes = {
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  changeSidebarVisibility: PropTypes.func.isRequired,
};

export default Topbar;
